import axios from 'axios';
import { ITEMS_PER_PAGE } from '../../components/pages/administration/CommonAdministrationPage';
import { headerConfig } from '../utils';
import { FETCH_ADMINISTRATION_DATA, REQUEST_RESULT } from '../types';
import { API_URL } from '../../config/environment-variables';
import { fetchAdministrationData } from './administration-actions';

const INVENTORY_ITEM_URL = `${API_URL}/inventoryItem`;
const [GET, CREATE, UPDATE] = ['Get', 'Create', 'Update'];

export function fetchInventoryItems(tableType, machineId, values, pageNumber, setSubmitting, setLoadingProgress) {
  let transformedResponse = [];
  const { search, text } = values ?? {};
  return dispatch => {
    axios.get(`${INVENTORY_ITEM_URL}/${GET}/${machineId}?pageSize=${ITEMS_PER_PAGE}&pageNumber=${pageNumber}${text ? `&${search}=${text}` : ''}`,
      {
        ...dispatch(headerConfig()),
        onDownloadProgress: (progressEvent) => {
          const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          setLoadingProgress && setLoadingProgress(progress);
        },
      })
      .then(response => {
        transformedResponse = {
          items: response.data.Items,
          machineId: machineId,
          pageCount: response.data.PageCount,
          totalCount: response.data.TotalItemCount,
          itemsFrom: response.data.ShowingNowFrom,
          itemsTo: response.data.ShowingNowTo,
          searchText: text,
        };
      })
      .then(() => {
        setSubmitting && setSubmitting(false);
        dispatch({
          type: FETCH_ADMINISTRATION_DATA,
          payload: transformedResponse,
        });
      })
      .catch(error => {
        setSubmitting && setSubmitting(false);
        dispatch({
          type: REQUEST_RESULT,
          payload: { message: error?.response?.data ?? 'Server error occurred' },
        });
      });
  };
}

export function addNewInventoryItem(tableType, machineId, values, setSubmitting, setNewlyCreatedItemName, page, setLoadingProgress, searchText) {
  if (values.ButtonColorHex) {
    values.ButtonColor = values.ButtonColorHex;
  }
  
  return dispatch => {
    axios.post(`${INVENTORY_ITEM_URL}/${CREATE}/${machineId}`,
      values,
      dispatch(headerConfig()))
      .then((response) => {
        setSubmitting(false);
        setNewlyCreatedItemName(response.data?.Description);
        dispatch({
            type: FETCH_ADMINISTRATION_DATA,
            payload: { items: [response.data] },
          });
        },
      )
      .catch(error => {
        setSubmitting && setSubmitting(false);
        if (error) {
          dispatch({
            type: REQUEST_RESULT,
            payload: { message: error.response.data },
          });
        }
      });
  };
}

export function updateInventoryItem(tableType, machineId, values, setSubmitting, page, setLoadingProgress, searchText) {
  const { Id } = values;
  // if (values && values.ButtonColorHex && !values.ButtonColorHex.includes('#')) {
  //   values.ButtonColor = values.ButtonColorHex;
  // }
  return dispatch => {
    axios.put(`${INVENTORY_ITEM_URL}/${UPDATE}/${Id}`,
      values,
      dispatch(headerConfig()))
      .then(() => {
          setSubmitting(false);
          dispatch(fetchAdministrationData(tableType, machineId, { text: searchText }, page, setSubmitting, setLoadingProgress));
        },
      );
  };
}

export function removeInventoryItem(tableType, machineId, itemId, setSubmitting, page, setLoadingProgress, searchText) {
  return dispatch => {
    axios.delete(`${INVENTORY_ITEM_URL}/${itemId}`,
      dispatch(headerConfig()))
      .then(() => {
        dispatch(fetchAdministrationData(tableType, machineId, { text: searchText }, page, setSubmitting, setLoadingProgress));
      }).catch(error => {
      if (error) {
        console.log(error.response.status);
        dispatch({
          type: REQUEST_RESULT,
          payload: { message: `Server error: ${error.response.status}` },
        });
      }
    });
  };
}